<template>
  <div class="content">
    <div class="content__ratio-list">
      <div
        v-for="(gasRatio, index) in data.ratios"
        :key="index"
      >
        <div class="content__gas-label">
          <gas-label :value="gasRatio.numerator"/> /
          <gas-label :value="gasRatio.denominator"/>
        </div>
        = <strong>{{ $n(gasRatio.result) }}</strong>
      </div>
    </div>
    <diagnostic-text-panel
      class="content__notes"
      :data="data"
      :alarmed="alarmed"
    />
  </div>
</template>
<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"

.content
  display: flex
  flex-direction: column
  +media-min-md
    flex-direction: row
    &__ratio-list
      flex: 2
    &__notes
      flex: 3
  &__gas-label
    display: inline-block
    width: 5.25rem
</style>
<script>
import GasLabel from '../common/GasLabel';
import DiagnosticTextPanel from '../common/DiagnosticTextPanel';

export default {
  components: {
    GasLabel,
    DiagnosticTextPanel,
  },
  props: {
    data: Object,
    alarmed: Boolean,
  },
};
</script>
